import { disableScroll } from '../functions/disable-scroll'
import { enableScroll } from '../functions/enable-scroll'

window.disableScroll = disableScroll
window.enableScroll = enableScroll

export default function modal() {
    let modals = document.querySelectorAll('.modal')

    if (!modals[0]) return;

    let wrapper = modals[0].parentElement
    // TODO: replace to [data-rent-modal-btn]
    let buttons = document.querySelectorAll('[data-rent-modal-open]')
    // let buttons = document.querySelectorAll('.rent--pc .rent-btn')
    // TODO: not necessary
    // let buttonsMobile = document.querySelectorAll('.rent--mobile .rent-btn')

    let openModal = (modalType) => {
        wrapper.classList.add('modal-wrapper--active');
        setModal(modalType);
        if (!document.body.classList.contains('dis-scroll')) {
            disableScroll();
        }
    }

    let closeModal = () => {
        wrapper.classList.remove('modal-wrapper--active');
        enableScroll();
    }

    let setModal = (modalType) => {
        modals.forEach(modal => {
            // if (modal.dataset.modal == 'rental') {
            //     let name = modal.querySelector('.modal__subtitle'),
            //         price = modal.querySelector('[data-total-price]'),
            //         priceUSD = modal.querySelector('[data-total-price-usd]'),
            //         priceInput = modal.querySelector('input[name="price"]'),
            //         deposit = modal.querySelector('[data-deposit]'),
            //         depositUSD = modal.querySelector('[data-deposit-usd]'),
            //         carSelect = modal.querySelector('input[name="carSelect"]');

            //     name.innerText = modalParams.name;
            //     price.innerText = modalParams?.price,
            //     priceInput.value = modalParams.price;
            //     priceUSD.innerText = modalParams?.priceUSD,
            //     carSelect.value = modalParams.name;
            //     select.addEventListener('change', () => {
            //         let carIDs = document.querySelector("[data-id-car='" + modalParams.idCar + "']");
            //         // let carIDs = document.querySelector("tr[data-id-car='" + modalParams.idCar + "']");
            //         tds = carIDs.querySelectorAll('[data-price-id]');
            //         // tds = carIDs.querySelectorAll('td');
            //         const deposit = document.querySelector('[data-deposit]')?.dataset?.deposit ?? 0;

            //         tds.forEach((th, i) => {
            //             if (th.dataset.priceId == select.value) {
            //                 modalParams.price = Number(th.dataset.price);
            //                 modalParams.priceUSD = Number(th.dataset.priceUsd);
            //                 modalParams.priceID = th.dataset.priceId;
            //                 setModal('rental');
            //             }
            //         })
            //         console.log(modalParams);
            //     })
            // }
            modal.dataset.modal == modalType ? modal.classList.add('modal--active') : modal.classList.remove('modal--active')
        })
    }

    let modalParams = {}
    let tableHead = document.querySelectorAll('th')
    let tr = [];
    let tds = [];

    modals.forEach(modal => {
        let close = modal.querySelectorAll('.js-modal-close');
        close.forEach(btn => btn.addEventListener('click', closeModal))
    });


//   document.body.addEventListener('click', (event) => {
//   const target = event.target;
// //   console.log(target);
//   if (target.classList.contains('js-order-car')) {
//     const tr = target.closest('[data-id-car]');
//     // console.log(tr);
//     const tds = tr.querySelectorAll('[data-price-id]');
//     const carName = tr.querySelector('[data-name]').dataset.name;
//     const deposit = tr.querySelector('[data-deposit]')?.dataset?.deposit ?? 0;
//     const depositUSD = deposit?.dataset?.deposit ?? 0;

//     const depEl = tr.querySelectorAll('[data-deposit]');
//     const jsDeposit = document.querySelector('.js-deposit');
  
//     jsDeposit.innerText = deposit;

//     modalParams.idCar = tr.dataset.idCar;

//     tds.forEach((th, i) => {
//       let idCarSelect = 1;
//       if (modalParams.priceID) {
//         idCarSelect = modalParams.priceID;
//       }
//       if (th.dataset.priceId == idCarSelect) {
//         modalParams.price = Number(th.dataset.price);
//         modalParams.priceUSD = Number(th.dataset.priceUsd);
//         modalParams.name = carName;
//       }
//     })

//     openModal('rental')
//   }
// });




    // buttons.forEach(btn => {
    //     btn.addEventListener('click', () => {
    //         // tr = btn.parentElement.parentElement;
    //         // tr = document.querySelector('.auto-block__content');
    //         tr = btn.closest('[data-id-car]');
    //         tds = tr.querySelectorAll('[data-price-id]');
    //         // tds = tr.querySelectorAll('td');
    //         const carName = tr.querySelector('[data-name]').dataset.name;
    //         const deposit = tr.querySelector('[data-deposit]')?.dataset?.deposit ?? 0;
    //
    //         // TODO: add idCar to rent-button parent
    //         modalParams.idCar = tr.dataset.idCar;
    //
    //         tds.forEach((th, i) => {
    //             let idCarSelect = 1;
    //             if (modalParams.priceID) {
    //                 idCarSelect = modalParams.priceID;
    //             }
    //             if (th.dataset.priceId == idCarSelect) {
    //                 modalParams.price = Number(th.dataset.price) + Number(deposit);
    //                 modalParams.name = carName;
    //                 // modalParams.name = tds[0].innerText;
    //             }
    //         })
    //         openModal('rental')
    //     });
    // });

    window.modalParams = modalParams

    // TODO: not necessary
    // buttonsMobile.forEach(btn => {
    //     btn.addEventListener('click', () => {
    //         tr = document.querySelector(".rent--pc tr[data-id-car='" + btn.dataset.idcar + "']");
    //         //console.log(tr);
    //         tds = tr.querySelectorAll('td');
    //         console.log(tds);
    //         modalParams.idCar = tr.dataset.idCar;
    //         tds.forEach((th, i) => {
    //             let idPriceSelect = 1;
    //             //console.log(modalParams, "modalParams");
    //             if (modalParams.priceID) {
    //                 idPriceSelect = modalParams.priceID;
    //             }

    //             if (th.dataset.priceId == idPriceSelect) {
    //                 modalParams.price = th.dataset.price;

    //                 modalParams.name = tds[0].dataset.name;

    //             }
    //         })
    //         console.log(modalParams);
    //         openModal('rental')
    //     });
    // });

    wrapper.addEventListener('click', (e) => {
        if (!e.target.closest('.modal')) {
            closeModal();
        }
    })

    let select = document.querySelector('[data-modal="rental"] select[name="tariff"]');
    let policyBtns = document.querySelectorAll('.js-policy');
    let termsBtns = document.querySelectorAll('.js-terms');
    let callbackBtns = document.querySelectorAll('.js-callback');

    policyBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            console.log('policy')
            openModal('policy')
        })
    })

    termsBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            openModal('terms')
        })
    })

    callbackBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            openModal('callback')
        })
    })

    let langBtns = document.querySelectorAll('button.modal__lang');

    langBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            let contents = btn.closest('.modal').querySelectorAll('.modal__inner--policy[data-lang]')
            contents.forEach(content => {
                if (content.dataset.lang == btn.dataset.lang) {
                    content.classList.add('modal__inner--active')
                    btn.classList.add('modal__lang--active')
                    contents.forEach(x => {
                        if (x.dataset.lang != btn.dataset.lang)
                            x.classList.remove('modal__inner--active')
                    })
                    btn.parentElement.querySelectorAll('button.modal__lang').forEach(x => {
                        if (x != btn)
                            x.classList.remove('modal__lang--active')
                    })
                }
            })
        })
    })

}
